import { useState, useEffect } from "react";

import Styled from "./OverflowMenuSelectionStyles";
import { Check, Color } from "../../ontego-ui";

export const OverflowMenuSelection = (props) => {
    const [activeItem, setActiveItem] = useState("");

    const { id, setValue, anchorElement, menuItems, setAnchorEl, selectedItem, withCheckMark } = props;

    useEffect(() => {
        setActiveItem(selectedItem);
    }, []);

    const closeAllMenus = () => {
        setAnchorEl(null);
    };

    const handleItemClick = (menuItem) => () => {
        setActiveItem(menuItem.text);
        setValue(menuItem.text);
        menuItem.onClick();
        closeAllMenus();
    };

    const renderMenuItem = (menuItem) => {
        const isSelected = activeItem === menuItem.text;

        return (
            <Styled.MenuItem
                key={menuItem.text}
                onClick={handleItemClick(menuItem)}
            >
                {withCheckMark && (
                    <Styled.MenuItemCheckIcon
                        style={{
                            color: isSelected ? Color.primary[500] : "transparent"
                        }}
                    >
                        <Check />
                    </Styled.MenuItemCheckIcon>
                )}
                <Styled.MenuItemText>
                    {menuItem.text}
                </Styled.MenuItemText>
            </Styled.MenuItem>
        );
    };

    return (
        <Styled.Menu
            id={id}
            anchorEl={anchorElement}
            keepMounted
            open={Boolean(anchorElement)}
            onClose={closeAllMenus}
        >
            {menuItems.map(menuItem => renderMenuItem(menuItem))}
        </Styled.Menu>
    );
}